<app-accessibility *ngIf="!hideAccessibility"></app-accessibility>
<div>
    <router-outlet></router-outlet>
</div>
<app-loader></app-loader>
